import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/pmpIdex",
    name: "index",
    component: () => import("@/views/common/PmpIndex"),
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/Login"),
  },
  {
    path: "/weekly",
    name: "weekly",
    component: () => import("@/views/weekly/Weekly"),
  },
  {
    path: "/itweekly",
    name: "itWeekly",
    component: () => import("@/views/weekly/ItWeekly"),
  },
  {
    path: "/xmcheck",
    name: "xmcheck",
    component: () => import("@/views/xmcheck/index"),
  },
  {
    path: "/xmcheck/xmxjList",
    name: "xmxjList",
    component: () => import("@/views/xmcheck/xmxjList"),
  },
  {
    path: "/xmcheck/fzxsjList",
    name: "fzxsjList",
    component: () => import("@/views/xmcheck/fzxsjList"),
  },
  {
    path: "/xmcheck/xsjmxList",
    name: "xsjmxList",
    component: () => import("@/views/xmcheck/xsjmxList"),
  },
  {
    path: "/xmcheck/zbxcjList",
    name: "zbxcjList",
    component: () => import("@/views/xmcheck/zbxcjList"),
  },
  {
    path: "/itzb",
    name: "itzb",
    component: () => import("@/views/weekly/Itzb"),
  },
  //项目成本核算
  {
    path: "/xmcbhs",
    name: "xmcbhs",
    component: () => import("@/views/xmcbhs/index"),
  },
  // {
  //   path: "/xmcbjsmx",
  //   name: "xmcbjsmx",
  //   component: () => import("@/views/xmcbhs/xmcbjsmx"),
  // },
  {
    path: "/taskList",
    name: "taskList",
    component: () => import("@/views/task/taskList"),
  },
  {
    path: "/reward/:taskId",
    name: "reward",
    component: () => import("@/views/reward/list"),
  },
  {
    path: "/taskType",
    name: "taskType",
    component: () => import("@/views/taskType/list"),
  },
  {
    path: "/reviewer",
    name: "reviewer",
    component: () => import("@/views/reviewer/list"),
  },
  {
    path: "/cgwList",
    name: "cgwList",
    component: () => import("@/views/cgw/cgwReviewList"),
  },
  {
    path: "/question",
    name: "question",
    component: () => import("@/views/question/questionList"),
  },
  {
    path: "/userManage",
    name: "userManage",
    component: () => import("@/views/userManage/list"),
  },
  {
    path: "/course/index",
    name: "courseIndex",
    component: () => import("@/views/course/index"),
  },


  {
    path: '/course',
    component: () => import('@/views/course/menu'),
    redirect: '/course/courseList',
    children: [
      {
        name: "courseList",
        path: 'courseList',
        component: () => import("@/views/course/courseList/list"),
      },
      {
        path: 'courseCharts',
        component: () => import("@/views/course/courseList/courseCharts/courseCharts"),
      },
      {
        path: 'courseArrange',
        name: 'courseArrange',
        component: () => import("@/views/course/courseList/courseArrange/arrangeList"),
      },
      {
        path: 'courseFile',
        name: 'courseFile',
        component: () => import("@/views/course/courseFile/list"),
      },
      {
        path: "judges",
        component: () => import("@/views/judges/list"),
      },
      {
        path: 'courseMeta',
        component: () => import("@/views/course/courseMeta/metaList"),
      },
      {
        name: 'propList',
        path: 'courseProp',
        component: () => import("@/views/course/courseMeta/propList"),
      },
      {
        path: "trackResult",
        name: 'trackResult',
        component: () => import("@/views/trackMonth/list"),
      },
      {
        path: 'ktcx',
        component: () => import("@/views/course/courseList/courseResult/courseKtcx"),
      },
      {
        path: "ktcgpfResult",
        component: () => import("@/views/trackMonth/ktcgpfList"),
      },
      {
        path: "lxsqResult",
        component: () => import("@/views/course/courseList/courseResult/courseLxsq"),
      },
      {
        path: "zqjcsqResult",
        component: () => import("@/views/course/courseList/courseResult/courseZqjc"),
      },
      {
        path: "jxcsResult",
        component: () => import("@/views/course/courseList/courseResult/courseJxcs"),
      },
      {
        path: "jxpsResult",
        component: () => import("@/views/course/courseList/courseResult/courseJxps"),
      },
      {
        path: "jxsqResult",
        component: () => import("@/views/course/courseList/courseResult/courseJxsq"),
      },
      {
        path: "yqjxsqResult",
        component: () => import("@/views/course/courseList/courseResult/courseYqjxsq"),
      },
      {
        path: "result",
        name: 'courseResult',
        component: () => import("@/views/course/courseList/result"),
      },

    ]
  },
  {
    path: "/program/add",
    name: "addProgram",
    component: () => import("@/views/program/addProgram"),
  },
  {
    path: "/xgpg/auditList",
    name: "auditList",
    component: () => import("@/views/xgpg/audit/auditList"),
  },
  {
    path: "/xgpg/apply/list",
    name: "xmApplyList",
    component: () => import("@/views/xgpg/xmApply/list"),
  },
  {
    path: "/xgpg/pscx/list",
    name: "xmPscxList",
    component: () => import("@/views/xgpg/xmApply/pscx"),
  },
  {
    path: "/xgpg/apply/clzd",
    name: "clzdApply",
    component: () => import("@/views/xgpg/xmApply/apply"),
  },
  {
    path: "/xgpg/apply/bgbx",
    name: "bgbxApply",
    component: () => import("@/views/xgpg/xmApply/apply2"),
  },
  {
    path: "/xgpg/pstjList",
    name: "pstjList",
    component: () => import("@/views/xgpg/pstjList"),
  },
  {
    path: "/zxlc/index",
    name: "zxlcIndex",
    component: () => import("@/views/zxlc/index/index"),
  },
  {
    path: "/zxlc/xmxy/xmxyfhList",
    name: "xmxyList",
    component: () => import("@/views/zxlc/xmxy/xmxyfhList"),
  },
  {
    path: "/zxlc/xmxy/xmxymxList",
    name: "xmxyList",
    component: () => import("@/views/zxlc/xmxy/xmxymxList"),
  },
  {
    path: "/zxlc/xmxy/xmxytjList",
    name: "xmxyList",
    component: () => import("@/views/zxlc/xmxy/xmxytjList"),
  },

  {
    path: "/zxlc/ybsbg/ybsbgtjList",
    name: "ybsbgtjList",
    component: () => import("@/views/zxlc/ybs/ybsbgtjList"),
  },
  {
    path: "/zxlc/ybsbg/ybsbgmxList",
    name: "ybsbgmxList",
    component: () => import("@/views/zxlc/ybs/ybsbgmxList"),
  },
  {
    path: "/zxlc/ybsbg/ybsbgfhList",
    name: "ybsbgfhList",
    component: () => import("@/views/zxlc/ybs/ybsbgfhList"),
  },
  {
    path: "/zxlc/ybsbg/hldbgmxList",
    name: "hldbgmxList",
    component: () => import("@/views/zxlc/ybs/hldbgmxList"),
  },

  {
    path: '/officePreview',
    component: () => import('@/views/zxlc/officePreview/index')
  },
  {
    path: "/pmp/kh/khhbyyList",
    name: "khhbyyList",
    component: () => import("@/views/hbyy/list"),
  },
  {
    path: "/pmp/kh/dsjList",
    name: "djsList",
    component: () => import("@/views/dsj/list"),
  },
  {
    path: "/pmp/kh/bindList",
    name: "bindList",
    component: () => import("@/views/jxgj/index"),
  },
  {
    path: "/projectFiles/index/:xmbh",
    name: "projectFiles",
    component: () => import("@/views/projectFiles/index"),
  },
  {
    path: "/xmzk/index",
    name: "xmzk",
    component: () => import("@/views/xmzk/index"),
  },
  {
    path: "/xmzk/ywgzgl",
    name: "ywgzgl",
    component: () => import("@/views/xmzk/ywgzgl"),
  },
  {
    path: "/xmzk/zbImport",
    name: "zbImport",
    component: () => import("@/views/xmzk/zbImport"),
  },
  {
    path: "/xmzk/fhsqgl",
    name: "fhsqgl",
    component: () => import("@/views/xmzk/fhsqgl"),
  },
  {
    path: "/xmzk/zhbb",
    name: "zhbb",
    component: () => import("@/views/xmzk/zhbb"),
  },
  {
    path: "/loading",
    name: "loading",
    component: () => import("@/views/common/myLoading"),
  },
  {
    path: "/svn/list",
    name: "svn",
    component: () => import("@/views/svn/list"),
  },
  // {
  //   path: "/soundRecording",
  //   name: "soundRecording",
  //   component: () => import("@/views/soundRecording/index"),
  // },

  {
    path: "/jxcp/yhsUpload",
    name: "yhsUpload",
    component: () => import("@/views/jxcp/yhsUpload"),
  },
  {
    path: "/jxcp/djlUpload",
    name: "djlUpload",
    component: () => import("@/views/jxcp/djlUpload"),
  },
  {
    path: "/jxcp/djlList",
    name: "djlList",
    component: () => import("@/views/jxcp/djlList"),
  },
  {
    path: "/jxcp/yhsList",
    name: "yhsList",
    component: () => import("@/views/jxcp/yhsList"),
  },

  {
    path: "/reportQuery/jsqxm",
    name: "jsqxm",
    component: () => import("@/views/reportQuery/jsqxmList"),
  },
  {
    path: "/reportQuery/lldtj",
    name: "lldtj",
    component: () => import("@/views/reportQuery/lldtjList"),
  },
  {
    path: "/reportQuery/zbts",
    name: "zbts",
    component: () => import("@/views/reportQuery/zbtsnrList"),
  },
  {
    path: "/reportQuery/qyzjgzltr",
    name: "qyzjgzltr",
    component: () => import("@/views/reportQuery/qyzjgzltrList"),
  },
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
});

export default router;
